import React from 'react';
import {Route, Routes,  Outlet} from 'react-router-dom';
import LandingPage from './components/LandingPage/landingPage';
import AboutUs from './components/AboutUs/aboutUs';
import SupportPage from './components/SupportPage/supportPage';
import DealsList from './components/Deals/dealsList'
import AddDealForm from './components/Deals/dealControllersUI/new'
import DealDetail from './components/Deals/dealControllersUI/dealDetail';
import UpdateDeal from './components/Deals/dealControllersUI/edit';
import LoginPage from './components/user/login';
import NewUser from './components/user/new';
import ProtectedRoute from '../src/components/AdminRoute/protectedRoute'
function AppRoutes(){
    return (
        <Routes>
            <Route path='/' element={<Outlet/>}/>
            {/* <Route path='/' element ={<LandingPage/>}/> */}
            <Route index element={<LandingPage/>} />
            <Route path='/about' element={<AboutUs/>}/>
            <Route path='/support' element={<SupportPage/>}/>
            <Route path='/discover' element={<DealsList/>}/>
            <Route path="/discover/deal/:id" element={<DealDetail/>} />
            <Route element={<ProtectedRoute />}>
                <Route path="/discover/new" element={<AddDealForm />} />
                <Route path="/discover/deal/:id/edit" element={<UpdateDeal />} />
            </Route>
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/signUp" element={<NewUser/>}/>
        </Routes>
    )
}
export default AppRoutes;